
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import ProjectsPage from '../pages/projects/page';
import AboutPage from '../pages/about/page';
import NotFoundPage from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/projects',
    element: <ProjectsPage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
